import { bindServices } from '@/services/api';
import { toImportExcel } from '@/services/global';
import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { queryEditActive } from './service';

const api = bindServices('customListGroups');

export const initialPagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  isOpenModal: false,
  selectedItem: null,
  pagination: initialPagination,
  view: false,
  orderBy: '',
  customListGroups: [],
  latestFetchCustomListGroups: null,
  showImport: false,
};

const Model = {
  namespace: 'customListGroups',

  state: initialState,

  effects: {
    *fetchData({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'customListGroup/paged',
          params: payload,
        });
        yield put({
          type: 'queryCustomListGroups',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });
        yield put({
          type: 'saveLatestFetchCustomListGroups',
          payload,
        });
      } catch (error) {
        /*  */
      }
    },
    *repeatLatestFetchCustomListGroups(__, { put, select }) {
      const latestPayload = yield select(
        (state) => state.customListGroups.latestFetchCustomListGroups,
      );
      yield put({
        type: 'fetchData',
        payload: latestPayload,
      });
    },

    *addNewCustomListGroup({ payload }, { put }) {
      yield put({
        type: 'addCustomListGroup',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewCustomListGroup',
          payload,
        });
      }
    },
    *saveNewCustomListGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'customListGroup',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveCustomListGroup',
          payload: response,
        });
        yield put({
          type: 'repeatLatestFetchCustomListGroups',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *saveEditCustomListGroup({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'customListGroup',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveCustomListGroup',
          payload: response,
        });

        yield put({
          type: 'repeatLatestFetchCustomListGroups',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        const response = yield call(api.apiRoute, {
          route: `customListGroup/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'deleteCustomListGroup',
          payload: response,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'repeatLatestFetchCustomListGroups',
        });
      } catch (error) {
        if (error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *fetchImport({ payload }, { call, put }) {
      try {
        const { file, isDeleteData } = payload;
        const res = yield call(toImportExcel, {
          route: 'customListGroup',
          fileContent: file,
          deleteExistingData: isDeleteData,
        });

        yield put({
          type: 'queryImport',
          payload: { ...res },
        });

        yield put({
          type: 'fetchData',
          payload: {
            page: 1,
            limit: 5,
          },
        });
      } catch (e) {}
    },
    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },
    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (e) {
        /*  */
      }
    },
  },
  reducers: {
    queryCustomListGroups(state, { payload }) {
      return {
        ...state,
        customListGroups: payload.items.map((item) => ({
          ...item,
          isActive: item.isActive ?? false,
        })),
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addCustomListGroup(state, { payload }) {
      return {
        ...state,
        isOpenModal: payload.isOpenModal,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewCustomListGroup(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    selectItem(state, { payload }) {
      const item = state.customListGroups.find(
        (customListGroup) => customListGroup.id === payload.id,
      );

      return {
        ...state,
        selectedItem: item,
        view: payload.view,
        id: payload.id,
      };
    },
    saveCustomListGroup(state, { payload }) {
      return {
        ...state,
        saveCustomListGroup: payload,
        isOpenModal: false,
        selectedItem: null,
        id: null,
        orderBy: '',
      };
    },
    deleteCustomListGroup(state) {
      return {
        ...state,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        isOpenModal: false,
        selectedItem: null,
        view: false,
        orderBy: '',
      };
    },
    resetState() {
      return initialState;
    },
    saveLatestFetchCustomListGroups(state, { payload }) {
      return {
        ...state,
        latestFetchCustomListGroups: payload,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    editActives(state, { payload }) {
      const customListGroups = state.customListGroups.map((item) =>
        item.id === payload.id ? payload : item,
      );
      return {
        ...state,
        customListGroups,
      };
    },
  },
};

export default Model;
